import { render, staticRenderFns } from "./ChangeBookingFare.vue?vue&type=template&id=18ed940f&scoped=true&"
import script from "./ChangeBookingFare.vue?vue&type=script&lang=js&"
export * from "./ChangeBookingFare.vue?vue&type=script&lang=js&"
import style0 from "./ChangeBookingFare.vue?vue&type=style&index=0&id=18ed940f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ed940f",
  null
  
)

export default component.exports